import { useAuth } from '@clerk/nextjs';
import { Container } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { useLocale } from 'hooks/useLocale';
import { saudiRewardsRetroRedeemMatchingOrdersQuery } from 'queries/saudi-rewards-retro-redeem/queries';

import { SaudiRewardsFormFields } from 'components/@account/types';
import { StepData } from 'components/@saudi-rewards/SaudiRewardsRetroRedeemContainer/types';
import MultiStep from 'components/@step-flow/MultiStep';

import Confirmation from './Steps/Confirmation';
import Info from './Steps/Info';
import LinkAccount from './Steps/LinkAccount';
import Orders from './Steps/Orders';

const INITIAL_VALUES: SaudiRewardsFormFields = {
  saudiRewardsMemberId: '',
  saudiRewardsMemberPin: '',
};

interface Props {
  redeemEmail: string;
  userExists: boolean;
  mismatchedEmail: boolean;
  saudiRewardsMemberId?: string;
}
const ClaimPointsFlow = ({
  userExists,
  mismatchedEmail,
  redeemEmail,
  saudiRewardsMemberId,
}: Props) => {
  const { locale } = useLocale();
  const { isSignedIn } = useAuth();

  // Prefetch orders for next step
  useQuery({
    ...saudiRewardsRetroRedeemMatchingOrdersQuery({ locale }),
    enabled: !!isSignedIn,
  });

  return (
    <Container
      maxWidth="xs"
      sx={{ mt: 1, display: 'flex', flexDirection: 'column', flexGrow: 1 }}
    >
      <MultiStep<StepData>
        initialValues={{
          ...INITIAL_VALUES,
          saudiRewardsMemberId: saudiRewardsMemberId ?? '',
        }}
      >
        <Info
          type={userExists ? 'signIn' : 'create'}
          redeemEmail={redeemEmail}
          mismatchedEmail={mismatchedEmail}
        />
        <LinkAccount />
        <Orders />
        <Confirmation />
      </MultiStep>
    </Container>
  );
};

export default ClaimPointsFlow;
